module.exports = __webpack_public_path__ + "static/img/desktop-sjdp.f2911e70.png";